var URL = require("url");
var USP = require("url-search-params"); // IE, Safari, Mobile Chrome, Mobile Safari
//import URL from 'url'
//import USP from 'url-search-params'
import fetch from './fetch'

var URLSearchParams = USP.default || USP

const globalHeaders = {
}

export function setGlobalHeader (name, value) {
  globalHeaders[name] = value
}

export function getGlobalHeader () {
  return globalHeaders
}

function processError (r, contentType) {
  if (contentType === 'application/json') {
    return r.json().then(res => {
      throw new Error(res ? res.description : r.status)
    })
  }
  throw new Error()
}

function processResponse (r) {
  let contentType = r.headers.get('content-type')
  if (!r.ok) {
    return processError(r, contentType)
  }
  if (contentType === 'application/json') {
    return r.json()
  } else if (contentType === 'application/octet-stream') {
    return r.blob()
  }
  return r
}

var buildUrl = function (baseUrl, path, queryParams) {
  if (path === void 0) { path = ''; }
  var searchParam = new URLSearchParams(URL.parse(baseUrl).search || undefined);
  baseUrl = baseUrl.split('?')[0];
  if (queryParams) {
      for (var key in queryParams) {
          if ({}.hasOwnProperty.call(queryParams, key)) {
              searchParam.append(key, queryParams[key]);
          }
      }
  }  
  var seperator = '';
  if (path && baseUrl.substr(-1) !== '/') {
      seperator = '/';
  }
  var params = searchParam.toString();
  if (params) {
      params = '?' + params;
  }
  return "" + baseUrl + seperator + path + params;
};

export default {
  post (url, payload, headers) {
    return fetch(url, {
      method: 'POST',
      headers: Object.assign({ 'Content-Type': 'application/json' }, globalHeaders, headers),
      body: JSON.stringify(payload)
    }).then(processResponse)
  },
  get (url) {
    return fetch(url, {
      headers: globalHeaders
    }).then(processResponse)
  },
  delete (url) {
    return fetch(url, {
      method: 'DELETE',
      headers: globalHeaders
    }).then(processResponse)
  },
  put (url, payload, headers) {
    return fetch(url, {
      method: 'PUT',
      headers: Object.assign({ 'Content-Type': 'application/json' }, globalHeaders, headers),
      body: JSON.stringify(payload),      
    }).then(processResponse)
  },
  requestService (serviceConfig, options) {
    var url = serviceConfig.url, requestOptions
    var _a = options, path = _a.path, queryParams = _a.queryParams, headers = _a.headers
    var requestUrl = buildUrl(url, path, queryParams);
    var requestOptions = { headers: headers }
    return fetch(requestUrl, requestOptions).then(processResponse)
  }
}




// WEBPACK FOOTER //
// ./client/src/util/http.js